<template>
  <div :class="themeIsDark ? 'text-white' : 'text-black'">
    <div class="relative z-10 mb-6">
      <p class="text-xl font-bold text-center mb-6 max-w-244 md:max-w-xl mx-auto" :style="$themeStyle" v-html="title"></p>
      <p class="text-sm text-center" :style="$themeStyle" v-html="text"></p>

    </div>
    <div class="flex-1 mb-8 chart-list">
      <div
        v-for="(track, index) in campaignSetlistTracks"
        :key="index"
        class="chart-track"
      >
        <div
          :class="index < campaignSetlistTracks.length - 1 ? 'border-b' : ''"
          class="flex flex-1 items-center pb-3 pt-3"
        >
          <div
            :class="themeIsDark ? 'bg-white' : 'bg-gray-150'"
            class="w-20 h-20 text-black p-2 flex justify-center items-center"
          >
            <span class="text-base">{{ index + 1 }}</span>
          </div>
          <div class="w-16 flex justify-center items-center">
            <Icon
              v-if="track.position_change > 0"
              :color="themeIsDark ? 'red' : 'black'"
              id="arrowUpTiny"
            />
            <Icon
              v-if="track.position_change < 0"
              :color="themeIsDark ? 'red' : 'black'"
              id="arrowDownTiny"
            />
            <span class="text-base ml-1">{{ track.position_change }}</span>
          </div>
          <img
            class="rounded-xl overflow-hidden p-2 w-24 h-24"
            :src="track.images[0].url"
          />
          <div class="ml-4 flex-1 flex items-center">
            <div class="ml-4 text-sm">
              <p class="mb-1">{{ track.name }}</p>
              <span class="text-gray-300">{{ track.artist_name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="mb-8 mx-auto">
        <Button
          @click.native="share"
          :title="isCopied ? $t('trackShareCopied') : buttonShare"
        />
      </div>
      <a
        @click="onOpenClick"
        class="text-base text-center block cursor-pointer mb-10"
        :href="playlistUrlShared"
        target="_blank"
        data-umg-event-type="ShopLink"
        data-umg-target="Shopify"
        :data-umg-variant="playlistUrlShared"
        data-umg-type="Streaming"
        v-if="buttonOpen"
      >
        {{ buttonOpen }}
      </a>
      <div
        role="button"
        class="text-base text-center block cursor-pointer"
        @click="restart"
        v-if="buttonRestart"
      >
        {{ buttonRestart }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { TranslationHandler } from '../../mixins/translation-handler'
import { PageModule, PageModuleDataChart, SetlistTrack } from '../../types'
import { copyToClipboard } from '@/utils/copy'
import { Component, Prop, Mixins } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { ThemeHandler } from '../../mixins/theme-handler'
import cms from '@/cms'

@Component({
  components: {
  }
})
export default class ModuleChart extends Mixins(TranslationHandler, ThemeHandler) {
  @Prop() pageModule!: PageModule<PageModuleDataChart>

  @Getter themeIsDark!: boolean
  @Getter themePrimaryColor!: string
  @Getter themeLogoImageUrl!: string

  @Getter campaignSetlistPlaylistId!: string
  @Getter campaignSetlistTracks!: SetlistTrack[]
  @Action('RESTART_JOURNEY') restartJourney!: () => void

  isCopied = false

  get playlistUrl (): string {
    return `https://open.spotify.com/embed/playlist/${this.campaignSetlistPlaylistId}`
  }

  get playlistUrlShared (): string {
    return `https://open.spotify.com/playlist/${this.campaignSetlistPlaylistId}`
  }

  get title () {
    return this.pageModule.data[this.$tLocaleCurrent].title
  }

  get text () {
    return this.pageModule.data[this.$tLocaleCurrent].text
  }

  get buttonRestart () {
    return this.pageModule.data[this.$tLocaleCurrent].buttonRestart
  }

  get buttonShare () {
    return this.pageModule.data[this.$tLocaleCurrent].buttonShare
  }

  get buttonOpen () {
    return this.pageModule.data[this.$tLocaleCurrent].buttonOpen
  }

  onOpenClick () {
    cms.tracking.trackClickout('shop_clickout', {
      clickout_type: 'Streaming',
      shop_name: 'Spotify',
    })
  }

  async share () {
    const url = window.location.origin + window.location.pathname
    // TODO: Move share function to SDK
    if (navigator.share) {
      cms.tracking.trackSocial('social_share_start')
      try {
        await navigator.share({
          title: this.title,
          url: url,
        })
        cms.tracking.trackSocial('social_share_success')
      } catch (e) {
        cms.tracking.trackSocial('social_share_fail', { error_message: (e as Error).toString() })
      }
    } else {
      try {
        copyToClipboard(url)
        this.isCopied = true
        cms.tracking.trackSocial('social_copy_link', { social_link: url })
      } catch (e) {
        console.log(e)
      }

      setTimeout(() => {
        this.isCopied = false
      }, 2000)
    }
  }

  restart () {
    // cms.tracking.trackGame('Restart', 'Successful', 'game_restart')
    // window.open(window.location.origin + window.location.pathname, '_self')
    this.restartJourney()
  }
}
</script>
